import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { LANDING_PAGE_URL } from 'utils/constants/endPoint'
import { SHIELD } from 'utils/constants/images'

export const AppFooter: FC = () => {
  const { t } = useTranslation()
  return (
    <div className="footer-wrapper text-center d-flex flex-column">
      <div className="d-flex align-items-center justify-content-center text-policy">
        <a
          href={LANDING_PAGE_URL.POLICY}
          className="d-flex align-items-center bases__gap8"
          target="_blank"
          rel="noreferrer"
        >
          <img src={SHIELD} alt="" />
          {t('login.policy')}
        </a>
      </div>
      <div className="text-copyright">{t('login.copy_right')}</div>
    </div>
  )
}
